import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CheckoutRoutes } from '@checkout/util-models';
import { ButtonLinkComponent } from '@domgen/dgx-fe-components/button';
import { TestHookDirective } from '@domgen/dgx-fe-components/general';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { GAClickDirective } from '@domgen/dgx-fe-ga';
import { LandingTestHooks } from '../../models/test/landing-test-hooks.enum';
import { LandingComponentService } from '../../services/landing-component/landing-component.service';

@Component({
  selector: 'checkout-guest',
  templateUrl: './checkout-guest.component.html',
  styleUrls: ['./checkout-guest.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [LandingComponentService],
  standalone: true,
  imports: [
    AsyncPipe,
    ButtonLinkComponent,
    GAClickDirective,
    IconComponent,
    NgIf,
    TestHookDirective,
  ],
})
export class CheckoutGuestComponent {
  readonly checkoutRoutesPersonalDetails: CheckoutRoutes =
    CheckoutRoutes.PersonalDetails;
  readonly testHooks = LandingTestHooks;

  constructor(readonly cs: LandingComponentService) {}
}
